<template>
  <div>
    <van-cell title="二手房买卖合同签约" v-if="detailInfo.busiType==='01'" :border="false" style="padding-left: 10px;font-weight: bolder;"/>
    <van-cell title="租赁合同签约" v-if="detailInfo.busiType==='02'" :border="false" style="padding-left: 10px;font-weight: bolder;"/>
    <card-detail v-for="(item) in detailInfo.buyerList" :key="item.sysGuid" :border="false" style="background: #FFFFFF;box-shadow: none" >
      <template #title>
        <van-cell v-if="detailInfo.busiType==='01'" title="买方信息" :border="false" style="padding-left: 0px;border-left: 5px solid #00dd02;line-height: 14px;"/>
        <van-cell v-if="detailInfo.busiType==='02'" title="甲方信息" :border="false" style="padding-left: 0px;border-left: 5px solid #00dd02;line-height: 14px;"/>
      </template>
      <template #content>
        <content-item contentLeft="姓名" :contentRight="item.personName"></content-item>
        <content-item contentLeft="身份证号" :contentRight="item.certNo"></content-item>
        <content-item contentLeft="银行卡号" v-if="detailInfo.busiType === '01' && item.bankCard != ''" :contentRight="item.bankCard"></content-item>
        <content-item contentLeft="手机号码" :contentRight="item.phoneNo"></content-item>
      </template>
    </card-detail>
    <card-detail v-for="(item) in detailInfo.sellerList" :key="item.sysGuid"  :border="false" style="background: #FFFFFF;box-shadow: none" >
      <template #title>
        <van-cell v-if="detailInfo.busiType==='01'" title="卖方信息" :border="false" style="padding-left: 0px;border-left: 5px solid #00dd02;line-height: 14px;"/>
        <van-cell v-if="detailInfo.busiType==='02'" title="乙方信息" :border="false" style="padding-left: 0px;border-left: 5px solid #00dd02;line-height: 14px;"/>
      </template>
      <template #content>
        <content-item contentLeft="姓名" :contentRight="item.personName"></content-item>
        <content-item contentLeft="身份证号" :contentRight="item.certNo"></content-item>
        <content-item contentLeft="手机号码" :contentRight="item.phoneNo"></content-item>
      </template>
    </card-detail>
    <card-detail  :border="false" style="background: #FFFFFF;box-shadow: none" >
      <template #title>
        <van-cell title="产权信息" :border="false" style="padding-left: 0px;border-left: 5px solid #00dd02;line-height: 14px;"/>
      </template>
      <template #content>
        <content-item contentLeft="行政区划" :contentRight="detailInfo.divisionName"></content-item>
        <content-item contentLeft="证明资料" :contentRight="detailInfo.proofTypeName"></content-item>
        <content-item contentLeft="不动产权证号" v-if="detailInfo.proofType === '01'" :contentRight="detailInfo.warrantNo"></content-item>
        <content-item contentLeft="购房合同号" v-if="detailInfo.proofType === '02'" :contentRight="detailInfo.contractNo"></content-item>
        <content-item contentLeft="不动产权证" v-if="detailInfo.proofType === '01'"></content-item>
        <content-item contentLeft="购房合同" v-if="detailInfo.proofType === '02'"></content-item>
        <van-grid :border="false" :column-num="3" style="margin-top: 10px" >
          <van-grid-item
              v-for="detail in detailInfo.viewPath"
              :key="detail" >
            <van-image  :src="detail" gutter="5px" @click="doImage(detail)"/>
          </van-grid-item>
        </van-grid>
      </template>
    </card-detail>

    <card-detail :border="false" v-if="detailInfo.status !== '1'" style="background: #FFFFFF;box-shadow: none" >
      <template #title>
        <van-cell title="办理信息" :border="false" style="padding-left: 0px;border-left: 5px solid #00dd02;line-height: 14px;"/>
      </template>
      <template #content>
        <content-item contentLeft="办理结果" :contentRight="detailInfo.statusName"></content-item>
        <content-item contentLeft="办理时间" :contentRight="detailInfo.handleTime"></content-item>
        <content-item contentLeft="办理说明" :contentRight="detailInfo.detail"></content-item>
      </template>
    </card-detail>

  </div>
</template>

<script>
import CardDetail from '@/components/card-detail.vue'
import ContentItem from '@/components/content-item.vue'
import { ImagePreview } from 'vant';
export default {
  name: "BusinessProcessDetail",
  components:{
    CardDetail,
    ContentItem,
  },
  data(){
    return {
      detailInfo: {
      },
      viewPathList:[
          "https://img.yzcdn.cn/vant/cat.jpeg",
          "https://img.yzcdn.cn/2.jpg"
      ]
    }
  },
  created() {
    this.initData();
  },
  methods:{
    initData(){
      this.detailInfo = this.$route.query.detailInfo;
    },
    doImage(url){
      let viewImage = []
      viewImage.push(url)
      ImagePreview({
        images: viewImage,
        //页面退出时自动关闭
        closeOnPopstate: true,
        showIndex: false
      });
    }

  }
}
</script>

<style scoped>



</style>